import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import PrimeirosClientes from './components/PrimeirosClientes';
import ComparacaoSacadas from './components/ComparacaoSacadas';
import VidroTipos from './components/VidroTipos';
import Servicos from './components/Servicos';
import GaleriaVideos from './components/GaleriaVideos';
import Estetica from './components/Estetica';
import OfertaEspecial from './components/OfertaEspecial';
import FrasesMotivadoras from './components/FrasesMotivadoras';
import RegioesAtendidas from './components/RegioesAtendidas';
import FAQSection from './components/FAQSection';
import ContatoFooter from './components/ContatoFooter';

export default function Home() {
  useEffect(() => {
    document.title = 'Envidraçamento de Sacada São Paulo | Fechamento Articulado Premium | Vidros Thelux';
    
    // Canonical dinâmico
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = 'https://vidrosthelux.com.br/';
    
    // OG Image
    let ogImage = document.querySelector('meta[property="og:image"]') as HTMLMetaElement | null;
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.content = 'https://readdy.ai/api/search-image?query=luxury%20modern%20apartment%20balcony%20with%20articulated%20frameless%20glass%20enclosure%20sliding%20panels%20open%20view%20S%C3%A3o%20Paulo%20city%20skyline%20premium%20finish%20natural%20light%20high%20end%20residential%20architecture%20editorial%20photography%20warm%20tones&width=1200&height=630&seq=og-home-001&orientation=landscape';
    
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Envidraçamento e fechamento de sacadas articuladas em São Paulo capital e Grande SP. Vidro temperado e laminado sem roldanas, NBR 7199. Atendemos Moema, Brooklin, Jardins, Morumbi, Pinheiros e todos os bairros. Orçamento grátis via WhatsApp (11) 98676-5185.'
      );
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        'content',
        'envidraçamento de sacada São Paulo, fechamento de sacada SP, vidro temperado sacada, sacada articulada sem roldana, envidraçamento Moema, fechamento sacada Brooklin, vidraçaria Jardins, envidraçamento Morumbi, envidraçamento Pinheiros, NBR 7199 São Paulo'
      );
    }
  }, []);

  return (
    <main className="min-h-screen font-sans">
      <HeroSection />
      <PrimeirosClientes />
      <ComparacaoSacadas />
      <VidroTipos />
      <Servicos />
      <RegioesAtendidas />
      <GaleriaVideos />
      <Estetica />
      <OfertaEspecial />
      <FrasesMotivadoras />
      <FAQSection />
      <ContatoFooter />
    </main>
  );
}